const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

const SENSITIVE_KEYS = new Set([
  'accountid',
  'userid',
  'token',
  'password',
  'secret',
  'apikey',
  'api_key',
  'authorization',
  'cookie',
  'ssn',
  'creditcard',
  'credit_card',
]);

export function filterMessagePII(message: string): string {
  return message.replace(EMAIL_REGEX, '[EMAIL_REDACTED]');
}

export function filterPII(obj: Record<string, unknown>): Record<string, unknown> {
  const filtered: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(obj)) {
    if (SENSITIVE_KEYS.has(key.toLowerCase())) {
      filtered[key] = '[REDACTED]';
    } else if (typeof value === 'string') {
      filtered[key] = filterMessagePII(value);
    } else if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      filtered[key] = filterPII(value as Record<string, unknown>);
    } else {
      filtered[key] = value;
    }
  }

  return filtered;
}
